module.exports = __webpack_public_path__ + "img/carte-cadeau-widddi.839aa7bd.jpg";